import { Injectable } from '@angular/core';
import { endpoints } from '@app/constants';
import { HttpService } from '@app/core/services/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { DeleteCreditCardPayload, DeleteCreditCardResponse } from './credit-card.models';

@Injectable({
  providedIn: 'root'
})
export class CreditCardService {

  constructor(private httpService: HttpService) { }

  public deleteCreditCard = (payload: DeleteCreditCardPayload): Observable<DeleteCreditCardResponse> => {
    return this.httpService
      .remove({ url: `${endpoints.zuora}${endpoints.paymentMethod}${payload.paymentMethodId}` })
      .pipe(
        mergeMap(this.handleDeleteCreditCard),
        catchError(err => {
          return throwError(err);
        })
    );
  }

  private handleDeleteCreditCard(response: DeleteCreditCardResponse): Observable<DeleteCreditCardResponse> {
    return of(response);
  } 
}
